import React from "react";

const ChatContext = React.createContext({
  setConnectionId: () => {},
  connectionId: {},
  onChatRefresh: () => {},
  isChatRefresh: true,
  setChatTitle: () => {},
  chatTitle: '',
  setAgentId: () => {},
  agentId: '',
  setToken: () => {},
  token: '',
  setAgentContextMapping: () => {},
  agentContextMapping: [],
  setChatSectionChatTitleList: () => {},
  chatSectionChatTitleList:[]
});

export default ChatContext;
